import React from 'react';

const TermsOfService = () => {
  return (
    <div className="policy-container">
      <h1 className="policy-title">Terms of Service</h1>
      
      <div className="policy-content">
        <div style={{ marginBottom: '20px' }}>
          <p style={{ marginBottom: '10px' }}>Website: <a href="http://www.omegaopscyberdefence.com">www.omegaopscyberdefence.com</a></p>
          <p style={{ marginBottom: '10px' }}>Email: <a href="mailto:corporate@omegaopscyberdefence.com">corporate@omegaopscyberdefence.com</a></p>
          <p style={{ marginBottom: '20px' }}>Effective Date: March 19th, 2025</p>
          <hr style={{ margin: '30px 0', border: 'none', borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }} />
        </div>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>1. Acceptance of Terms</h2>
          <p>By accessing this website, you agree to be bound by these Terms of Service ("Terms"). If you do not agree, please do not use this site.</p>
          <p>These Terms apply only to the corporate website and do not govern the use of Omega Void&trade; or any associated applications or services.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>2. Corporate Purpose</h2>
          <p>Omega Ops Cybernetics Defence Corp. operates this website to provide general information about the company, our mission, team, and representation of our products, including Omega Void&trade; and others under development.</p>
          <p>No direct services, products, or transactions are offered or sold through this site.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>3. Intellectual Property</h2>
          <p>All content on this site—including text, graphics, logos, trademarks, and design—is the exclusive property of Omega Ops Cybernetics Defence Corp. or its licensors and is protected under applicable intellectual property laws. Use of this content without permission is strictly prohibited.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>4. Disclaimer of Warranties</h2>
          <p>The content on this site is provided "as is" for informational purposes only. Omega Ops Cybernetics Defence Corp. makes no warranties, express or implied, including but not limited to fitness for a particular purpose, accuracy, or non-infringement.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>5. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Omega Ops Cybernetics Defence Corp. is not liable for any damages, direct or indirect, arising from your use of the corporate website or product.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>6. External Links</h2>
          <p>This site may link to third-party sites or products, including Omega Void&trade;. Omega Ops Cybernetics Defence Corp. is not responsible for the content or practices of those external sites.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>7. Governing Law</h2>
          <p>These Terms shall be governed by and construed in accordance with the laws of Canada and the United States, without regard to conflict of law principles. Any legal action shall be brought in a court of competent jurisdiction located in Canada and the United States.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>8. Changes to Terms</h2>
          <p>Omega Ops Cybernetics Defence Corp. reserves the right to update or modify these Terms at any time. Your continued use of the site constitutes acceptance of the updated Terms.</p>
        </section>
        
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>9. Contact</h2>
          <p>For any inquiries, please contact us at:</p>
          <p style={{ marginTop: '10px' }}><a href="mailto:corporate@omegaopscyberdefence.com">corporate@omegaopscyberdefence.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;